import { BrandCategory } from '@innovationdepartment/proxima-sdk-axios';

export const BRAND_CATEGORY_LABELS: Record<BrandCategory, string> = {
  [BrandCategory.Beauty]: 'Beauty',
  [BrandCategory.Children]: 'Children',
  [BrandCategory.FashionAccessories]: 'Fashion & Accessories',
  [BrandCategory.FoodDrink]: 'Food & Drink',
  [BrandCategory.Health]: 'Health',
  [BrandCategory.HobbiesLeisure]: 'Hobbies & Leisure',
  [BrandCategory.Home]: 'Home',
  [BrandCategory.Other]: 'Other',
  [BrandCategory.Pets]: 'Pets',
  [BrandCategory.Travel]: 'Travel'
};

export const brandCategoryOptions: { label: string; value: BrandCategory }[] = Object.values(
  BrandCategory
).map(value => ({ label: BRAND_CATEGORY_LABELS[value], value }));
